import DistrictList from "./DistrictList";
import DistrictEdit from "./DistrictEdit";
import DistrictShow from "./DistrictShow";
import DistrictIcon from "@mui/icons-material/LocationCity";

const Districts = {
  list: DistrictList,
  edit: DistrictEdit,
  show: DistrictShow,
  icon: DistrictIcon,
};

export default Districts;
